import React, { Component } from 'react';
import './index.scss';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { ReactComponent as InSeatDeliveryIcon } from '../../assets/images/in-seat-delivery-icon.svg';
import { ReactComponent as PickupAtCounterIcon } from '../../assets/images/to-be-picked-up-icon.svg';
const setPaymentPages = window.location.pathname === '/payment';
const setPages = window.location.pathname === '/confirmation';

class BookingSummary extends Component {
  constructor(props) {
    const params = new URLSearchParams(window.location.search);
    let cinemaId = params.get('cinemaid');
    super(props);
    this.state = {
      currentIndex: 0,
      ticketSummarySectionHeight: 0,
      openTicketSummary: false,
      maxHeightForTicketSummary: 'auto',
      deliveryTypeSelectionEnabled:
        window.constant.SHOW_DELIVERY_TYPE.ALL_LOCATIONS == true ? window.constant.SHOW_DELIVERY_TYPE.ALL_LOCATIONS : window.constant.SHOW_DELIVERY_TYPE.ACTIVE_LOCATIONS.includes(cinemaId),
      deliveryTypeOverride: window.constant?.DELIVERY_TYPE_OVERRIDE?.ALL_LOCATIONS || "delivery"
    };
    this.ticketSummarySectionRef = React.createRef();
    this.purchaseFooterRef = React.createRef();
  }

  componentDidMount() {
    let deliveryTypeOverride = this.state.deliveryTypeOverride;
    if (window.constant?.DELIVERY_TYPE_OVERRIDE?.LOCATION_SPECIFIC?.length > 0) {
      window.constant?.DELIVERY_TYPE_OVERRIDE?.LOCATION_SPECIFIC.forEach(location => {
        if (location.id === localStorage.getItem("cinemaid")) {
          deliveryTypeOverride = location.type
        }
      });
    }

    this.setState({ deliveryTypeOverride })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ticketsDataForTicketSummary !== this.props.ticketsDataForTicketSummary || prevProps.fnbDataForTicketSummary !== this.props.fnbDataForTicketSummary) {
      this.setState({ cart: this.props.cart });
    }
  }

  getItemTotalWithFreeQty = item => {
    var unitprice = parseFloat(item.unitprice) || 0;
    var modifiers = item.modifiers || [];
    var modifierGroups = item.modifierGroups || [];

    if (modifiers.length === 0) return unitprice;

    if (modifierGroups.length === 0) {
      modifiers.forEach(modifier => {
        unitprice += (parseFloat(modifier.unitprice) || 0) * (modifier.qty || 0);
      });
      return unitprice;
    }

    var consumedModifierIndexes = {};
    var totalModifiersPrice = 0;

    modifierGroups.forEach(group => {
      var freeQty = group.freeQty || 0;
      var selectedModifiers = [];
      var groupId = group.id || group.modifierGroupId || group.modifiergroupid || group.groupid || group.groupId;

      modifiers.forEach((modifier, modifierIndex) => {
        var modifierGroupId = modifier.modifierGroupId || modifier.modifiergroupid || modifier.modifier_group_id || modifier.groupid || modifier.groupId;
        if (groupId == null || modifierGroupId == null || String(groupId) !== String(modifierGroupId)) return;

        var qty = modifier.qty || 0;
        var price = parseFloat(modifier.unitprice) || 0;
        consumedModifierIndexes[modifierIndex] = true;
        for (var i = 0; i < qty; i++) {
          selectedModifiers.push(price);
        }
      });

      selectedModifiers.sort((a, b) => a - b);
      var remainingFreeQty = freeQty;
      var paidModifiers = [];
      selectedModifiers.forEach(price => {
        if (price > 0 && remainingFreeQty > 0) {
          remainingFreeQty -= 1;
        } else {
          paidModifiers.push(price);
        }
      });
      totalModifiersPrice += paidModifiers.reduce((sum, price) => sum + price, 0);
    });

    modifiers.forEach((modifier, modifierIndex) => {
      if (!consumedModifierIndexes[modifierIndex]) {
        totalModifiersPrice += (parseFloat(modifier.unitprice) || 0) * (modifier.qty || 0);
      }
    });

    return unitprice + totalModifiersPrice;
  };

  calculateTotal = () => {
    var totalTicketPricing = 0,
      totalFnbPricing = 0,
      grandTotal = 0,
      bookingFee = this.props.bookingFee == false ? 0 : this.props.bookingFee,
      tax = this.props.tax == false ? 0 : this.props.tax;
    this.props.ticketsDataForTicketSummary.length > 0 &&
      this.props.ticketsDataForTicketSummary.map(eachTicket => {
        var itemTotal = this.getItemTotalWithFreeQty(eachTicket);
        totalTicketPricing += eachTicket.qty * itemTotal;
      });

    grandTotal += totalTicketPricing;
    this.props.fnbDataForTicketSummary.length > 0 &&
      this.props.fnbDataForTicketSummary.map(eachFnb => {
        var itemTotal = this.getItemTotalWithFreeQty(eachFnb);
        totalFnbPricing += eachFnb.qty * itemTotal;
      });
    grandTotal += totalFnbPricing;

    if (this.props.serviceTaxData?.length > 0) {
      grandTotal += this.props.serviceTaxData[0]?.pricebeforetax;
    }

    grandTotal += bookingFee;
    grandTotal += tax;

    return grandTotal.toFixed(2);
  };

  populateTicketsForTicketSummary = () => {
    var returnTicketsDiv = [];
    this.props.ticketsDataForTicketSummary.length > 0 &&
      this.props.ticketsDataForTicketSummary.map(eachTicket => {
        var itemTotal = this.getItemTotalWithFreeQty(eachTicket);
        returnTicketsDiv.push(
          <div
            // // // // // className="eachTicketDiv"
            className={`eachTicketDiv ${window.constant.ENABLE_VOUCHERS === 'true' && eachTicket.voucherCode && eachTicket.voucherCode != '' ? 'voucherType' : ''}`}
          >
            {/* <span className="name">{eachTicket.description}</span> */}
            <p className="name">
              {eachTicket.description}
              {window.constant.ENABLE_VOUCHERS === 'true' ? <>{eachTicket.voucherCode && eachTicket.voucherCode != '' ? <span className="voucherCode">({eachTicket.voucherCode})</span> : ''}</> : ''}
            </p>
            <span className="eachQty">
              ${itemTotal.toFixed(2)} x {eachTicket.qty}
            </span>
            <div className="priceDiv">
              <p className="price">${parseFloat(itemTotal * eachTicket.qty).toFixed(2)}</p>
            </div>
          </div>
        );
      });

    return returnTicketsDiv;
  };

  populateFnBForTicketSummary = () => {
    var returnFnBDiv = [];
    let fnbItemsPickupAtCounter = [];
    let fnbItemsInSeatDelivery = [];
    console.log(this.props.fnbDataForTicketSummary, "this.props.fnbDataForTicketSummary from booking summary");
    this.props.fnbDataForTicketSummary.length > 0 &&
      this.props.fnbDataForTicketSummary.map((eachFnb, eachFnbIndex) => {
        var unitprice = this.getItemTotalWithFreeQty(eachFnb);
        var modifers = [];
        var smartModifiers = '';
        eachFnb.modifiers.length > 0 &&
          eachFnb.modifiers.forEach((modifier, index) => {
            modifers.push(
              <span
                key={index}
                className={modifier?.isSoldOut ? 'is-sold-out' : ''}
              >
                {modifier.description} x {modifier.qty}
                {index < eachFnb.modifiers.length - 1 ? ', ' : ''}
              </span>
            )
          });
        eachFnb.smartModifiers.length > 0 &&
          eachFnb.smartModifiers.map(smartModifer => {
            smartModifiers += smartModifer.description + ', ';
          });
        if (this.state.deliveryTypeSelectionEnabled) {
          if (eachFnb.pickupAtCounter && eachFnb.inSeatDelivery) {
            if (this.state.deliveryTypeOverride === "delivery") {
              fnbItemsInSeatDelivery.push(
                <div
                  // className="eachTicketDiv"
                  className={`eachTicketDiv ${window.constant.ENABLE_VOUCHERS === 'true' && eachFnb.voucherCode && eachFnb.voucherCode != '' ? 'voucherType' : ''}`}
                >
                  <div className="name">
                    <p>
                      {eachFnb.description}
                      {window.constant.ENABLE_VOUCHERS === 'true' ? <>{eachFnb.voucherCode && eachFnb.voucherCode != '' ? <span className="voucherCode">({eachFnb.voucherCode})</span> : ''}</> : ''}
                    </p>
                    {modifers.length == 0 && smartModifiers.length == 0 ? (
                      <></>
                    ) : (
                      <span className="modifiers">
                        {modifers}
                        {modifers.length > 0 && smartModifiers.length > 0 ? ', ' : ''}
                        {smartModifiers}
                      </span>
                    )}
                  </div>

                  <span className="eachQty">
                    {!this.props.incDecItem ? (
                      <>
                        ${unitprice.toFixed(2)} x {eachFnb.qty}
                      </>
                    ) : (
                      <div className="incDecDivForItem">
                        <button type="button" class="btn btn-outline-secondary decButton" onClick={() => this.props.incDecItem('subtract', eachFnbIndex)}>
                          <FaMinus></FaMinus>
                        </button>
                        <button type="button" class="btn btn-outline-secondary itemQty">
                          {eachFnb.qty}
                        </button>
                        <button
                          type="button"
                          class={`btn btn-outline-secondary incButton ${eachFnb.addBtnDisabled ? 'disabled' : ''}`}
                          onClick={() => this.props.incDecItem('add', eachFnbIndex)}
                          disabled={eachFnb.disableIncOption}
                        >
                          <FaPlus></FaPlus>
                        </button>
                      </div>
                    )}
                  </span>
                  <div className="priceDiv">
                    {eachFnb.originalPrice != null && eachFnb.voucherCode == '' ? <p className="originalPrice eachQty">${parseFloat(eachFnb.originalPrice * eachFnb.qty).toFixed(2)}</p> : ''}
                    <p>${parseFloat(unitprice * eachFnb.qty).toFixed(2)}</p>
                  </div>
                </div>
              );

            } else if (this.state.deliveryTypeOverride === "pickup") {
              fnbItemsPickupAtCounter.push(
                <div
                  // className="eachTicketDiv"
                  className={`eachTicketDiv ${window.constant.ENABLE_VOUCHERS === 'true' && eachFnb.voucherCode && eachFnb.voucherCode != '' ? 'voucherType' : ''}  ${eachFnb?.isSoldOut ? 'is-sold-out' : ''}`}
                >
                  <div className="name">
                    <p>
                      {eachFnb.description}
                      {window.constant.ENABLE_VOUCHERS === 'true' ? <>{eachFnb.voucherCode && eachFnb.voucherCode != '' ? <span className="voucherCode">({eachFnb.voucherCode})</span> : ''}</> : ''}
                    </p>
                    {modifers.length == 0 && smartModifiers.length == 0 ? (
                      <></>
                    ) : (
                      <span className="modifiers">
                        {modifers}
                        {modifers.length > 0 && smartModifiers.length > 0 ? ', ' : ''}
                        {smartModifiers}
                      </span>
                    )}
                  </div>

                  <span className="eachQty">
                    {!this.props.incDecItem ? (
                      <>
                        ${unitprice.toFixed(2)} x {eachFnb.qty}
                      </>
                    ) : (
                      <div className="incDecDivForItem">
                        <button type="button" class="btn btn-outline-secondary decButton" onClick={() => this.props.incDecItem('subtract', eachFnbIndex)}>
                          <FaMinus></FaMinus>
                        </button>
                        <button type="button" class="btn btn-outline-secondary itemQty">
                          {eachFnb.qty}
                        </button>
                        <button
                          type="button"
                          class={`btn btn-outline-secondary incButton ${eachFnb.addBtnDisabled ? 'disabled' : ''}`}
                          onClick={() => this.props.incDecItem('add', eachFnbIndex)}
                          disabled={eachFnb.disableIncOption}
                        >
                          <FaPlus></FaPlus>
                        </button>
                      </div>
                    )}
                  </span>
                  <div className="priceDiv">
                    {eachFnb.originalPrice != null && eachFnb.voucherCode == '' ? <p className="originalPrice eachQty">${parseFloat(eachFnb.originalPrice * eachFnb.qty).toFixed(2)}</p> : ''}
                    <p>${parseFloat(unitprice * eachFnb.qty).toFixed(2)}</p>
                  </div>
                </div>
              );
            }
          } else if (eachFnb.pickupAtCounter) {
            console.log("3rd called");
            fnbItemsPickupAtCounter.push(
              <div
                // className="eachTicketDiv"
                className={`eachTicketDiv ${window.constant.ENABLE_VOUCHERS === 'true' && eachFnb.voucherCode && eachFnb.voucherCode != '' ? 'voucherType' : ''}  ${eachFnb?.isSoldOut ? 'is-sold-out' : ''}`}
              >
                <div className="name">
                  <p>
                    {eachFnb.description}
                    {window.constant.ENABLE_VOUCHERS === 'true' ? <>{eachFnb.voucherCode && eachFnb.voucherCode != '' ? <span className="voucherCode">({eachFnb.voucherCode})</span> : ''}</> : ''}
                  </p>
                  {modifers.length == 0 && smartModifiers.length == 0 ? (
                    <></>
                  ) : (
                    <span className="modifiers">
                      {modifers}
                      {modifers.length > 0 && smartModifiers.length > 0 ? ', ' : ''}
                      {smartModifiers}
                    </span>
                  )}
                </div>

                <span className="eachQty">
                  {!this.props.incDecItem ? (
                    <>
                      ${unitprice.toFixed(2)} x {eachFnb.qty}
                    </>
                  ) : (
                    <div className="incDecDivForItem">
                      <button type="button" class="btn btn-outline-secondary decButton" onClick={() => this.props.incDecItem('subtract', eachFnbIndex)}>
                        <FaMinus></FaMinus>
                      </button>
                      <button type="button" class="btn btn-outline-secondary itemQty">
                        {eachFnb.qty}
                      </button>
                      <button
                        type="button"
                        class={`btn btn-outline-secondary incButton ${eachFnb.addBtnDisabled ? 'disabled' : ''}`}
                        onClick={() => this.props.incDecItem('add', eachFnbIndex)}
                        disabled={eachFnb.disableIncOption}
                      >
                        <FaPlus></FaPlus>
                      </button>
                    </div>
                  )}
                </span>
                <div className="priceDiv">
                  {eachFnb.originalPrice != null && eachFnb.voucherCode == '' ? <p className="originalPrice eachQty">${parseFloat(eachFnb.originalPrice * eachFnb.qty).toFixed(2)}</p> : ''}
                  <p>${parseFloat(unitprice * eachFnb.qty).toFixed(2)}</p>
                </div>
              </div>
            );
          } else if (eachFnb.inSeatDelivery) {
            console.log("4th called");
            fnbItemsInSeatDelivery.push(
              <div
                // className="eachTicketDiv"
                className={`eachTicketDiv ${window.constant.ENABLE_VOUCHERS === 'true' && eachFnb.voucherCode && eachFnb.voucherCode != '' ? 'voucherType' : ''}`}
              >
                <div className="name">
                  <p>
                    {eachFnb.description}
                    {window.constant.ENABLE_VOUCHERS === 'true' ? <>{eachFnb.voucherCode && eachFnb.voucherCode != '' ? <span className="voucherCode">({eachFnb.voucherCode})</span> : ''}</> : ''}
                  </p>
                  {modifers.length == 0 && smartModifiers.length == 0 ? (
                    <></>
                  ) : (
                    <span className="modifiers">
                      {modifers}
                      {modifers.length > 0 && smartModifiers.length > 0 ? ', ' : ''}
                      {smartModifiers}
                    </span>
                  )}
                </div>

                <span className="eachQty">
                  {!this.props.incDecItem ? (
                    <>
                      ${unitprice.toFixed(2)} x {eachFnb.qty}
                    </>
                  ) : (
                    <div className="incDecDivForItem">
                      <button type="button" class="btn btn-outline-secondary decButton" onClick={() => this.props.incDecItem('subtract', eachFnbIndex)}>
                        <FaMinus></FaMinus>
                      </button>
                      <button type="button" class="btn btn-outline-secondary itemQty">
                        {eachFnb.qty}
                      </button>
                      <button
                        type="button"
                        class={`btn btn-outline-secondary incButton ${eachFnb.addBtnDisabled ? 'disabled' : ''}`}
                        onClick={() => this.props.incDecItem('add', eachFnbIndex)}
                        disabled={eachFnb.disableIncOption}
                      >
                        <FaPlus></FaPlus>
                      </button>
                    </div>
                  )}
                </span>
                <div className="priceDiv">
                  {eachFnb.originalPrice != null && eachFnb.voucherCode == '' ? <p className="originalPrice eachQty">${parseFloat(eachFnb.originalPrice * eachFnb.qty).toFixed(2)}</p> : ''}
                  <p>${parseFloat(unitprice * eachFnb.qty).toFixed(2)}</p>
                </div>
              </div>
            );
          }
        } else {
          returnFnBDiv.push(
            <div
              // className="eachTicketDiv"
              className={`eachTicketDiv ${window.constant.ENABLE_VOUCHERS === 'true' && eachFnb.voucherCode && eachFnb.voucherCode != '' ? 'voucherType' : ''} ${eachFnb?.isSoldOut ? 'is-sold-out' : ''}`}
            >
              <div className="name">
                <p>
                  {eachFnb.description}
                  {window.constant.ENABLE_VOUCHERS === 'true' ? <>{eachFnb.voucherCode && eachFnb.voucherCode != '' ? <span className="voucherCode">({eachFnb.voucherCode})</span> : ''}</> : ''}
                </p>
                {modifers.length == 0 && smartModifiers.length == 0 ? (
                  <></>
                ) : (
                  <span className="modifiers">
                    {modifers}
                    {modifers.length > 0 && smartModifiers.length > 0 ? ', ' : ''}
                    {smartModifiers}
                  </span>
                )}
              </div>

              <span className="eachQty">
                {!this.props.incDecItem ? (
                  <>
                    ${unitprice.toFixed(2)} x {eachFnb.qty}
                  </>
                ) : (
                  <div className="incDecDivForItem">
                    <button type="button" class="btn btn-outline-secondary decButton" onClick={() => this.props.incDecItem('subtract', eachFnbIndex)}>
                      <FaMinus></FaMinus>
                    </button>
                    <button type="button" class="btn btn-outline-secondary itemQty">
                      {eachFnb.qty}
                    </button>
                    <button
                      type="button"
                      class={`btn btn-outline-secondary incButton ${eachFnb.addBtnDisabled ? 'disabled' : ''}`}
                      onClick={() => this.props.incDecItem('add', eachFnbIndex)}
                      disabled={eachFnb.disableIncOption}
                    >
                      <FaPlus></FaPlus>
                    </button>
                  </div>
                )}
              </span>
              <div className="priceDiv">
                {eachFnb.originalPrice != null && eachFnb.voucherCode == '' ? <p className="originalPrice eachQty">${parseFloat(eachFnb.originalPrice * eachFnb.qty).toFixed(2)}</p> : ''}
                <p>${parseFloat(unitprice * eachFnb.qty).toFixed(2)}</p>
              </div>
            </div>
          );
          return returnFnBDiv;
        }
      });
    return (
      <>
        {this.state.deliveryTypeSelectionEnabled ? (
          <>
            {fnbItemsPickupAtCounter.length > 0 && (
              <>
                <div className="delivery-type-label pick-up">
                  <span className="icon">
                    <PickupAtCounterIcon />
                  </span>
                  <p className="label">Picked Up at the Concessions Counter</p>
                </div>
                {fnbItemsPickupAtCounter}
                {fnbItemsInSeatDelivery.length > 0 && <div className="separator"></div>}
              </>
            )}
            {fnbItemsInSeatDelivery.length > 0 && (
              <>
                <div className="delivery-type-label in-seat">
                  <span className="icon">
                    <InSeatDeliveryIcon />
                  </span>
                  <p className="label">{
                    window.constant.SHOW_DELIVERY_TYPE.DELIVERY_TYPE_DRAWER_ENABLED ? "Available for Delivery your Seat" : "Delivered to your seat"
                  }</p>
                </div>
                {fnbItemsInSeatDelivery}
              </>
            )}
          </>
        ) : (
          <>{returnFnBDiv}</>
        )}
      </>
    );
  };

  render() {
    const { fnbDataForTicketSummary, ticketsDataForTicketSummary, giftcardPaymentTypes, getRemainingOrderValue, paymentsTypes, setRedeemcardData } = this.props;
    return (
      <>
        {ticketsDataForTicketSummary.length > 0 && (
          <>
            <div className="separator"></div>
            <p className="heading">Ticket(s)</p>
            <div>{this.populateTicketsForTicketSummary()}</div>
          </>
        )}
        {fnbDataForTicketSummary.length > 0 ? (
          <>
            <div className="separator"></div>
            <p className="heading fnb">Food and Drink(s)</p>
            <div>{this.populateFnBForTicketSummary()}</div>
          </>
        ) : (
          <></>
        )}
        {!this.props.bookingFee && !this.props.tax ? <></> : <div className="separator"></div>}
        {!this.props.bookingFee ? (
          <></>
        ) : (
          <div className="eachTicketDiv">
            <span className="name preCost">
              Booking Fee <span className="secondaryFontRegular"></span>
            </span>
            <p className="eachQty"></p>
            <div className="priceDiv">
              <p className="price preCost">${this.props.bookingFee.toFixed(2)}</p>
            </div>
          </div>
        )}

        {!this.props.serviceTaxData?.length > 0 ? (
          <></>
        ) : (
          <>
            <div className="eachTicketDiv">
              <span className="name preCost">
                {window.constant.SERVICE_FEE_TEXT ? window.constant.SERVICE_FEE_TEXT : "Service Fee"} <span className="secondaryFontRegular"></span>
              </span>
              <p className="eachQty"></p>
              <div className="priceDiv">
                <p className="price preCost">${this.props.serviceTaxData[0]?.pricebeforetax.toFixed(2)}</p>
              </div>
            </div>
          </>
        )}


        {!this.props.tax ? (
          <></>
        ) : (
          <div className="eachTicketDiv">
            <span className="name preCost">
              Tax <span className="secondaryFontRegular"></span>
            </span>
            <p className="eachQty"></p>
            <div className="priceDiv">
              <p className="price preCost">${this.props.tax.toFixed(2)}</p>
            </div>
          </div>
        )}

        <div className="separator"></div>
        <div className="eachTicketDiv">
          <span className="name totalCost">Total Cost</span>
          <p className="eachQty"></p>
          <div className="priceDiv">
            <p className="price totalCost">${this.calculateTotal()}</p>
          </div>
        </div>

        {window.constant.REWARDS_REDEMPTION &&
          setRedeemcardData &&
          Object.keys(setRedeemcardData).length > 0 &&
          setRedeemcardData.cardinformation &&
          Object.keys(setRedeemcardData.cardinformation).length > 0 &&
          setRedeemcardData.cardinformation.amountToDeduct ? (
          <>
            <div className="eachTicketDiv reward-redeem-price-blk">
              <span className="name">
                {window.constant.REDEMPTION_TEXT} <i>({setRedeemcardData.cardinformation.cardNumber})</i>
              </span>
              <p className="eachQty"></p>
              <div className="priceDiv">
                <p className="price">-${setRedeemcardData.cardinformation.amountToDeduct.toFixed(2)}</p>
              </div>
            </div>

            {(giftcardPaymentTypes && giftcardPaymentTypes.length == 0 && setPaymentPages) || (Object.keys(setRedeemcardData).length > 0 && setPages) ? (
              <>
                <div className="separator"></div>
                <div className="eachTicketDiv">
                  <span className="name totalCost">{setPaymentPages ? 'To pay' : 'Total'}</span>
                  <p className="eachQty"></p>
                  <div className="priceDiv">
                    <p className="price totalCost">${(this.calculateTotal() - setRedeemcardData.cardinformation.amountToDeduct).toFixed(2)}</p>
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}

        {setPaymentPages &&
          giftcardPaymentTypes.length > 0 &&
          giftcardPaymentTypes.map(giftcardData => {
            if (giftcardData.type.toLowerCase() === 'giftcard') {
              return (
                <>
                  <div className="eachTicketDiv giftcard-payment giftcard">
                    <span className="name preCost">
                      {giftcardData.pgName} ({Object.keys(giftcardData.cardinformation).length > 0 ? giftcardData.cardinformation.cardNumber : ''})
                    </span>
                    <div className="priceDiv">
                      <p className="price preCost">&minus; ${Object.keys(giftcardData.cardinformation).length > 0 ? giftcardData.cardinformation.amountToDeduct.toFixed(2) : ''}</p>
                    </div>
                  </div>
                  <div className="separator"></div>
                  <div className="eachTicketDiv giftcard-payment">
                    <span className="name totalCost">To Pay</span>
                    <div className="priceDiv">
                      <p className="price totalCost">${getRemainingOrderValue.toFixed(2)}</p>
                    </div>
                  </div>
                </>
              );
            }
          })}

        {paymentsTypes && paymentsTypes.length > 0 && setPages ? (
          <div className="payments-types">
            <div className="separator"></div>
            <div className="heading">Payment Summary</div>
            {paymentsTypes.map(paymentsData => {
              return (
                <div className="eachTicketDiv">
                  <span className="name preCost">
                    {paymentsData.pgName}
                    {paymentsData.cardinformation && Object.keys(paymentsData.cardinformation).length > 0 && paymentsData.cardinformation.cardNumber && (
                      <strong>({paymentsData.cardinformation.cardNumber})</strong>
                    )}
                  </span>
                  <div className="priceDiv">
                    <p className="price preCost">${paymentsData.amount && paymentsData.amount.toFixed(2)}</p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <></>
        )}

        {this.props.nextBtnText.length == 0 ? (
          <></>
        ) : (
          <div className="w-100 text-center">
            <button type="button" className="continueButton" onClick={() => this.props.nextBtnClick()}>
              {this.props.nextBtnText}
            </button>
          </div>
        )}
      </>
    );
  }
}

export default BookingSummary;
